import React from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from 'entities/user/selectors';
import LinkTab from 'retired/LinkTab';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';

const Tabs = () => {
  const user = useSelector(selectUser);

  if (!user) {
    return null;
  }

  const isActionsFeatureEnabled = user?.hasFeature(Features.ACTIONS);

  return (
    <div>
      {user.hasFeature(Features.VOLUNTEERING) && user.hasPrivilege(Privileges.EVENT_MANAGE) && (
        <LinkTab label="Volunteer Events" path="/deeds/volunteer" />
      )}
      {user.hasFeature(Features.EVENTS) && user.hasPrivilege(Privileges.BASE_EVENT_MANAGE) && (
        <LinkTab label="Events" path="/deeds/events" />
      )}
      {user.canDonate() && user.hasPrivilege(Privileges.FUNDRAISER_MANAGE) && (
        <LinkTab label="Fundraisers" path="/deeds/campaigns" />
      )}
      {user.hasFeature(Features.VOLUNTEERING) && user.hasPrivilege(Privileges.PROJECT_MANAGE) && (
        <LinkTab label="Projects" path="/deeds/projects" />
      )}
      {isActionsFeatureEnabled && user?.hasPrivilege(Privileges.ACTIONS_MANAGE) && (
        <LinkTab label="Actions" path="/deeds/actions" />
      )}
    </div>
  );
};

export default Tabs;
